/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { toast } from "../index";

let id = crypto.randomUUID();

export function showToast(
  status: "info" | "warning" | "success" | "error" | "loading" | undefined,
  description: string,
  title?: string
) {
  if (toast.isActive(id)) toast.close(id);
  id = crypto.randomUUID();
  return toast({ status, title, description, id });
}

export function parseJwt(token: string) {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
}

export function isNumeric(n: string) {
  return !isNaN(parseFloat(n)) && isFinite(parseInt(n));
}

export function isOperationAllowed(mainRoute: string, subroute?: string) {
  const permisions = parseJwt(
    sessionStorage.getItem("token") || ""
  )?.Permissions;
  return mainRoute
    ? subroute
      ? permisions?.includes(`${mainRoute}-${subroute}`)
      : permisions?.includes(mainRoute)
    : true;
}

interface NestedObject {
  name?: string;
  id?: string;
  [key: string]: any; // Allow other dynamic properties
}

export function transformJSON(
  data: Record<string, NestedObject | any>
): Record<string, string | any> {
  const transformed: Record<string, string | any> = {};

  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];

      if (
        value &&
        typeof value === "object" &&
        (value.id !== undefined || value.name !== undefined)
      ) {
        // If the value is an object and has `id` or `name`, use `id` (fallback to `name`)
        transformed[key] = value.id !== undefined ? value.id : value.name;
      } else {
        // Otherwise, keep the value as is
        transformed[key] = value;
      }
    }
  }

  return transformed;
}
